import { DiagramState, DiagramAction, DiagramActionTypes as ActionTypes } from './types';

const initialDiagramState: DiagramState = {
  refresh: {},
  isLoading: false,
  isLoading2: false,
  isSubmitting: false,
  isNavigating: false,
  isNavigatingTo: null,
  diagram: null,
  selectEquipments: [],
};

const diagramReducer = (
  state: DiagramState = initialDiagramState,
  action: DiagramAction,
): DiagramState => {
  switch (action.type) {
    case ActionTypes.INIT:
      return initialDiagramState;

    case ActionTypes.REFRESH:
      return { ...state, refresh: {} };

    case ActionTypes.LOADING:
      return { ...state, isLoading: action.payload };

    case ActionTypes.LOADING2:
      return { ...state, isLoading2: action.payload };

    case ActionTypes.SUBMITTING:
      return { ...state, isSubmitting: action.payload };

    case ActionTypes.NAVIGATING:
      return { ...state, isNavigating: action.payload };

    case ActionTypes.NAVIGATING_TO:
      return { ...state, isNavigatingTo: action.payload };

    case ActionTypes.SET_DIAGRAM:
      return { ...state, diagram: action.payload };

    case ActionTypes.SET_SELECT_EQUIPMENTS:
      return { ...state, selectEquipments: action.payload };

    default:
      return state;
  }
};

export default diagramReducer;
